import { classNames } from "@punks/ui-core"

export interface ContainerProps {
  children: any
  className?: string
  hFull?: boolean
  fluid?: boolean
  fluidXs?: boolean
  fluidSm?: boolean
  fluidMd?: boolean
  fluidLg?: boolean
  noGutters?: boolean
  noGuttersXs?: boolean
  noGuttersSm?: boolean
  noGuttersMd?: boolean
  noGuttersLg?: boolean
  wide?: boolean
}

const Container = ({
  children,
  wide,
  fluid,
  fluidXs,
  fluidSm,
  fluidMd,
  fluidLg,
  noGutters,
  noGuttersXs,
  noGuttersSm,
  noGuttersMd,
  noGuttersLg,
  className,
  hFull,
}: ContainerProps) => {
  return (
    <div
      className={classNames(
        {
          "mx-auto": !wide,
          container:
            !fluid && !fluidXs && !fluidSm && !fluidMd && !fluidLg && !wide,
          "sm:container": fluidXs && !wide,
          "md:container": fluidSm && !wide,
          "lg:container": fluidMd && !wide,
          "xl:container": fluidLg && !wide,
          "h-full": hFull,
          "px-container":
            !noGutters &&
            !noGuttersXs &&
            !noGuttersSm &&
            !noGuttersMd &&
            !noGuttersLg &&
            !wide,
          "sm:px-container": noGuttersXs,
          "md:px-container": noGuttersSm,
          "lg:px-container": noGuttersMd,
          "xl:px-container": noGuttersLg,
          "w-full sm:px-14": wide,
        },
        className
      )}
    >
      {children}
    </div>
  )
}

export default Container
